import React from "react";
import Layout from "../../components/organisms/Layout";
import Details from "../../components/pages/product-detail/Details";
import Insurance from "../../components/molecules/InsuranceList";
import IMG from "../../assets/images/product-detail/company/GASTOS_MÉDICOS.png";
import { DetailWithImage } from "../../components/pages/quote/DetailWithImage";
import Technology from "../../components/pages/product-detail/Technology";

const Accident = ({}) => {
	return (
		<Layout landingPage='company'>
			<Details
				type='medical-expense-group'
				title={"Seguro de Gastos Médicos Grupal"}
			/>
			<DetailWithImage
				title={
					<h1>
						Salud para <span className='text-primary'>tus colaboradores</span>
					</h1>
				}
				content='Obtén coberturas por nivel de riesgo de los colaboradores de toda la empresa, con deducibles y coaseguros específicos a sus necesidades, mejorando costos y coberturas.'
				image={IMG}
			/>
			<Technology />
			<Insurance
				type='company'
				current='medical-expense-group'
				title='Una amplia gama de seguros'
			/>
		</Layout>
	);
};
export default Accident;
